module.exports = __webpack_public_path__ + "static/media/yt-clothing.67ce0882.jpeg";